import React from "react";
import { useDispatch } from "react-redux";

import { LicenseApi } from "../../api";

import MtiButton from "../Buttons/MtiButton";
import IconApp from "../../Icons/AppIcon";

import { sendNotification } from "../../redux/actions/NotificationAction";

import { ENotificationType } from "../../Model";

type LiceseRequestProps = {
  onBack?: () => void;
  onClose?: () => void;
  onStartRequest?: () => void;
  onStopRequest?: () => void;
};

export function LicenseRequestModal(props: Readonly<LiceseRequestProps>) {
  const { onBack, onClose, onStartRequest, onStopRequest } = props;

  const dispatch = useDispatch();

  const sendRequestLicense = async () => {
    try {
      onStartRequest?.();

      const value = await LicenseApi.requestManual();
      const licenseRequestInfo = value.licenseRequestString;

      if (licenseRequestInfo) {
        let link = document.createElement("a");
        link.download = "License Request Info.txt";
        link.href =
          "data:text/plain;charset=utf-8," +
          encodeURIComponent(licenseRequestInfo);
        link.click();
      }
    } catch (error) {
      console.error(error);
      dispatch(
        sendNotification(
          ENotificationType.Error,
          "An error occurred while requesting the license info"
        )
      );
    } finally {
      onStopRequest?.();
      onBack?.();
      onClose?.();
    }
  };

  const NOP = () => {};

  return (
    <>
      <div data-testid="LR" className="login-title">
        <div className="title-container">
          <IconApp width="34" height="34" viewBox="0 0 48 48" fill="none" />
          <p>
            ROCK IMAGER<sup>®</sup>
          </p>
        </div>
      </div>
      <div className="license-content">
        <div className="license-header">Request License</div>
        <div className="license-body">
          <p>
            To activate the license, click Download File and email it to <strong>licensing@formulatrix.com</strong>
          </p>
        </div>
        <div className="license-footer">
          <MtiButton
            size="large"
            style={{ width: 200, marginRight: 15 }}
            onClick={sendRequestLicense}
          >
            DOWNLOAD FILE
          </MtiButton>
          <MtiButton
            size="large"
            style={{ width: 150 }}
            variant="secondary"
            onClick={onBack ?? onClose ?? NOP}
          >
            {onBack ? "BACK" : "CLOSE"}
          </MtiButton>
        </div>
      </div>
    </>
  );
}

export default LicenseRequestModal;
